import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import Reversecoding from "../../assets/event-images/reversecoding.jpg";

const rapidCoding = {
  image: Reversecoding,
  description:
    "Dive into the thrill of rapid coding at our symposium! Solve standard coding questions within tight timeframes, showcasing your coding prowess under pressure. Earn points for each problem cracked accurately, and compete against the clock to claim the top spot!",
  type: "Golden-Byte Event",
  eventName: "Rapid Coding",
  dateTime: "Feb 28, 10:00AM - 12:00PM",
  venue: "IT-443",
  rules: [
    "Solo Participation.",  
"Challenges will be conducted on Hackerrank.",  
"All participants should have a Hackerrank account.",  
"Computers will be provided, but in case of technical difficulties, participants are requested to bring their personal laptop.",  
"All programming languages are accepted.",  
"Questions will be of Easy, Medium, and Hard.",  
"Duration: 2hrs.",  
"Points: Easy questions: 50, Medium questions: 75, Hard questions: 100.",  
"The participant with the highest points will be declared as the winner."
],

  firstprize: 1,
  secondprize: 1000,
  thirdprize: 0,
  contact: [
    {
      name: "Sanjith Sivendra K",
      phoneNo: "8344449586",
    },
    {
      name: "Santosh Narayanan",
      phoneNo: "9952761591",
    },
  ],
};

const RapidCoding = () => {
  return <SingleEventPage eventDetails={rapidCoding} isCoinPrize={true} />;
};

export default RapidCoding;
